export default function isAdmin({next} : { next: any }) {
  if(!localStorage.getItem("adminToken")) return next({ name: "Login" })
  return next()
}
